import { useAtom } from 'jotai'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'

const { atom, resetAtom } = createAtom<string>('', MMKVKey.FilePath)

export const useFilePathAtom = () => useAtom(atom)
export const useResetFilePathAtom = () => useAtom(resetAtom)
